<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="姓名" class="fn-left">
            <el-input v-model="listQuery.name" type="text" placeholder="请输入名称" />
          </el-form-item>
          <el-form-item label="部门" class="fn-left">
            <department-select :selected.sync="listQuery.departmentId" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetUserHistory()">查询 </el-button>
            <!-- <el-button type="info">查看走势</el-button> -->
            <a :href="requestUrl + '/Stock/downloadStockGiveOut'" style="margin-left:20px" target="_blank">
              <el-button type="success">导出股金开启员工明细</el-button>
            </a>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="historyLists" border stripe>
        <el-table-column label="姓名" prop="name" align="center" />
        <el-table-column label="职位" prop="title" align="center" />
        <el-table-column label="持股" align="center">
          <template slot-scope="{row}">
            <p>{{ row.total_share_num/100 | formatMoney }}</p>
          </template>
        </el-table-column>
        <el-table-column label="现价" align="center">
          <template slot-scope="{row}">
            <p>{{ parseFloat(row.share_price)/100 }}</p>
          </template>
        </el-table-column>
        <el-table-column label="市值" align="center">
          <template slot-scope="{row}">
            <p>{{ row.stock_value/100 | formatMoney }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnDetail(row.uid)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="员工股份" class="employ_stock_dialog" custom-class="custom_stock_dialog" :visible.sync="bShowDetailDialog" width="700px">
      <el-table :key="stockListTableKey" :data="stockLists" border stripe>
        <el-table-column label="创建日期" prop="create_time" align="center" />
        <el-table-column label="行权日期" prop="effective_date" align="center" />
        <el-table-column label="股数" align="center">
          <template slot-scope="{row}">
            <p>{{ row.share_holding/100 | formatMoney }}</p>
          </template>
        </el-table-column>
        <el-table-column label="发放股价" align="center">
          <template slot-scope="{row}">
            <p>{{ row.share_price/100 }}</p>
          </template>
        </el-table-column>
        <el-table-column label="股金类型" prop="exercise_type_name" align="center" />
        <el-table-column label="奖励类型" prop="award_type_name" align="center" />
        <el-table-column label="状态" prop="status_name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button v-if="row.status == 1" type="text" @click="fnReviewBack(row.equity_capital_id,row.uid)">撤回</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>

</template>

<script>
import Tool from '@/assets/js/tool.js'

import DepartmentSelect from './DepartmentSelect'

import commondata from '@/utils/commondata'

export default {
  name: 'WaitSendStockLists',
  components: {
    DepartmentSelect
  },
  filters: {
    formatMoney: function(val) {
      return Tool.formatMoney(val, true)
    }
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      stockListTableKey: 0,
      historyLists: [],
      stockLists: [],
      stockTypes: commondata.STOCK_TYPE,
      bShowDetailDialog: false,
      listQuery: {
        name: '',
        departmentId: ''
      },
      requestUrl: process.env.VUE_APP_BASE_URL

    }
  },
  created() {
    this.fnGetUserHistory()
  },
  methods: {
    fnGetUserHistory() {
      this.bShowDetailDialog = false
      this.$http.getUserStockList(this.listQuery).then(res => {
        this.tableKey++
        this.historyLists = res.data || []
      })
    },
    findArray(list, key, value) {
      return Tool.findIndexInArryByKeyVal(list, key, value)
    },
    fnDetail(uid) {
      this.$http.getUserEquityCapitalList({ uid }).then(res => {
        this.stockListTableKey++
        this.stockLists = res.data || []
        this.bShowDetailDialog = true
      })
    },
    fnReviewBack(equityCapitalId, uid) {
      this.$confirm('是否撤回行权中的股票？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.revocationCapital({ equityCapitalId }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '撤回成功'
            })
            this.fnDetail(uid)
          }
        })
      }).catch(() => {

      })
    },
    changeTime(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    },
    fnSendAllStock() {
      this.$confirm('是否确认操作一键发放股金？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.giveCapital().then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '发放成功'
            })
            this.fnGetUserHistory()
          }
        })
      }).catch(() => {

      })
    }

  }
}
</script>
<style lang="scss" >
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
.abow_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden;
    .el-dialog {
        margin: 0 auto !important;
        height: 90%;
        overflow: hidden;
        .el-dialog__body {
            position: absolute;
            left: 0;
            top: 60px;
            bottom: 0;
            right: 0;
            padding: 30px;
            z-index: 1;
            overflow: hidden;
            overflow-y: auto;
        }
    }
}

.custom_stock_dialog {
  max-height: 90vh;
}

</style>
